"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
const utils_1 = require("./utils");
function getProductJson(productMicrodataIO) {
    const { name, image, brand, description, offers, review, aggregateRating, gtin, sku, productId, url, imageObject, videoObject, width, height, depth, weight, mpn, } = productMicrodataIO;
    let finalJson = `
    {
      "@context": "http://schema.org",
      "@type": "Product",
      "name": "${utils_1.addslashes(name)}"
  `;
    if (image) {
        finalJson += `,"image": [
      ${utils_1.toArray(image)
            .map(element => '"' + element + '"')
            .join(',')}
    ]   `;
    }
    if (productId) {
        finalJson += `,"productID": "${productId}"`;
    }
    if (url) {
        finalJson += `,"url": "${url}"`;
    }
    if (brand) {
        finalJson += `,"brand": ${utils_1.getBrandJson(brand)}`;
    }
    if (description) {
        finalJson += `,"description": "${utils_1.addslashes(description)}"`;
    }
    if (offers) {
        finalJson += `,"offers": ${utils_1.getOfferJson(offers)}`;
    }
    if (gtin) {
        let gtinKey = 'gtin';
        switch (gtin.length) {
            case 8: {
                gtinKey = 'gtin8';
                break;
            }
            case 13: {
                gtinKey = 'gtin13';
                break;
            }
            case 14: {
                gtinKey = 'gtin14';
                break;
            }
        }
        finalJson += `,"${gtinKey}": "${gtin}"`;
    }
    if (sku) {
        finalJson += `,"sku": "${sku}"`;
    }
    if (imageObject) {
        finalJson += `,"image": [
        ${utils_1.toArray(imageObject)
            .map(element => utils_1.getImageObjectJson(element))
            .join(',')}
      ]   `;
    }
    if (videoObject) {
        finalJson += `,"video": [
      ${utils_1.toArray(videoObject)
            .map(element => utils_1.getVideoObjectJson(element))
            .join(',')}
    ]   `;
    }
    if (width) {
        finalJson += `,"width": "${width}"`;
    }
    if (height) {
        finalJson += `,"height": "${height}"`;
    }
    if (depth) {
        finalJson += `,"depth": "${depth}"`;
    }
    if (weight) {
        finalJson += `,"weight": "${weight}"`;
    }
    if (mpn) {
        finalJson += `,"mpn": "${mpn}"`;
    }
    finalJson += '}';
    return finalJson;
}
exports.getProductJson = getProductJson;
exports.ProductMicrodata = ({ name, image, brand, description, offers, review, aggregateRating, gtin, sku, productId, url, imageObject, videoObject, width, height, depth, weight, mpn, }) => {
    const finalJson = getProductJson({
        name,
        image,
        brand,
        description,
        offers,
        review,
        aggregateRating,
        gtin,
        sku,
        productId,
        url,
        imageObject,
        videoObject,
        width,
        height,
        depth,
        weight,
        mpn,
    });
    return (React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { type: "application/ld+json" }, finalJson)));
};
